var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseModal',[_c('BaseCard',{attrs:{"title":"Add New"}},[_c('template',{slot:"action"},[_c('BaseButton',{staticClass:"cancel",attrs:{"icon":"el-icon-close"},on:{"click":_vm.exitForm}},[_vm._v(" Cancel ")])],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }